import { css } from 'emotion';

export const segmentStyles = css`
  min-width: 150px;
`;
